// removed by extract-text-webpack-plugin
module.exports = {"inputDotacion":"InputDotacionSimple__inputDotacion___1FBDN shared__inputNumberAsText___1Qr9M","inputDotacionDirty":"InputDotacionSimple__inputDotacionDirty___1vYs6 InputDotacionSimple__inputDotacion___1FBDN shared__inputNumberAsText___1Qr9M","inputDotacionInvalida":"InputDotacionSimple__inputDotacionInvalida___3fhJi InputDotacionSimple__inputDotacion___1FBDN shared__inputNumberAsText___1Qr9M","divConTooltip":"InputDotacionSimple__divConTooltip____kOso","tooltip":"InputDotacionSimple__tooltip___1GLLq"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/components/shared/InputDotacionSimple.css
// module id = 646
// module chunks = 0